import React from "react";

import { IDSSLoader } from "../../DSSFramework";
import { Spinner } from "../../../dls/dls-loader/spinner-view";

const DSSSpinner = ({ label, id = "spinnet", ...props }: IDSSLoader) =>
{
    return (
        <Spinner label={ label } id={ id } { ...props } />
    );
};
export default DSSSpinner;